import { Formik } from 'formik';
import React from 'react';
import * as Yup from 'yup';

import Button from '../buttons/Button';
import InputField from '../forms/fields/InputField';
import BaseModal from './BaseModal';

interface CoordinatesModalProps {
    isOpen: boolean;
    handleClose: () => void;
    handleSubmit: (values: { lat: number; lng: number }) => void;
}

function CoordinatesModal({ isOpen, handleClose, handleSubmit }: CoordinatesModalProps) {
    return (
        <BaseModal open={isOpen} handleClose={handleClose}>
            <div className="relative p-6">
                <h3 className="text-center mb-6">Vnesi koordinate</h3>
                <Formik
                    initialValues={{
                        lat: '',
                        lng: ''
                    }}
                    validationSchema={Yup.object().shape({
                        lat: Yup.number()
                            .transform((o, v) => parseFloat(String(v).replace(/,/g, '.')))
                            .typeError('Vnesite število.')
                            .min(-90)
                            .max(90)
                            .required('Vnesi zemljepisno širino.'),
                        lng: Yup.number()
                            .transform((o, v) => parseFloat(String(v).replace(/,/g, '.')))
                            .typeError('Vnesite število.')
                            .min(-180)
                            .max(180)
                            .required('Vnesi zemljepisno dolžino')
                    })}
                    onSubmit={(values) => {
                        handleSubmit({
                            lat: parseFloat(values.lat.replace(/,/g, '.')),
                            lng: parseFloat(values.lng.replace(/,/g, '.'))
                        });
                    }}
                >
                    {({ errors, handleBlur, handleChange, handleSubmit, touched, values }) => (
                        <form onSubmit={handleSubmit}>
                            <div className="mb-4">
                                <InputField
                                    label={
                                        <>
                                            Zemljepisna širina{' '}
                                            <span className="text-secondary text-sm font-light">(Latitude)</span>
                                        </>
                                    }
                                    value={values.lat}
                                    error={Boolean(touched.lat && errors.lat)}
                                    helperText={touched.lat && errors.lat}
                                    type="text"
                                    name="lat"
                                    placeholder="46.123456"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                />
                            </div>
                            <div className="mb-6">
                                <InputField
                                    label={
                                        <>
                                            Zemljepisna dolžina{' '}
                                            <span className="text-secondary text-sm font-light">(Longitude)</span>
                                        </>
                                    }
                                    value={values.lng}
                                    error={Boolean(touched.lng && errors.lng)}
                                    helperText={touched.lng && errors.lng}
                                    type="text"
                                    name="lng"
                                    placeholder="15.123456"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                />
                            </div>
                            <div className="flex justify-between items-center">
                                <Button
                                    variant="text"
                                    color="secondary"
                                    onClick={(e) => {
                                        e.preventDefault();
                                        handleClose();
                                    }}
                                >
                                    Zapri
                                </Button>
                                <Button color="primary" type="submit">
                                    Potrdi
                                </Button>
                            </div>
                        </form>
                    )}
                </Formik>
            </div>
        </BaseModal>
    );
}

export default CoordinatesModal;
